import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Icon, Pane, Paneset } from '@folio/stripes/components';
/**
 * CZNA-1627 — what a route the user may not open renders instead of its screen, so a URL
 * shared by a colleague explains itself rather than silently landing on the dashboard.
 * Stateless on purpose: it must not mount the protected screen nor call anything (CZNA-1440).
 */
var AccessDenied = function (_a) {
    var homePath = _a.homePath;
    return (React.createElement(Paneset, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-authorities.accessDenied.title" }) },
            React.createElement("div", { "data-test-access-denied": true, style: { textAlign: 'center', padding: '40px' } },
                React.createElement(Icon, { icon: "exclamation-circle", size: "large" }),
                React.createElement("h3", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.accessDenied.heading" })),
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.accessDenied.message" })),
                React.createElement(Link, { to: homePath },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.accessDenied.goToDashboard" }))))));
};
export default AccessDenied;
